// @flow
import { BigNumber } from "bignumber.js";
import error from "./errorReporter";

export type DumbObject =
  | number
  | string
  | Array<DumbObject>
  | {
      [key: number | string]: DumbObject
    };

export type AxiosError = {
  response: ?{
    data: any,
    status: number,
    headers: { [string]: string }
  },
  request?: XMLHttpRequest,
  message?: string
};

export type Action = {
  type: string,
  error?: AxiosError
};
export type ActionWithData<D> = {
  ...Action,
  data?: D
};

export type State = {
  error?: ?AxiosError
};
export type StateWithData<D> = {
  ...State,
  data?: D
};
export type StateWithDataAndFields<D, F> = {
  ...StateWithData<D>,
  ...F
};

export type numberDouble = BigNumber;

export const int = (i: string | number): number => {
  let r = 0;
  if (!isNaN(i)) r = parseInt(i, 10);

  if (isNaN(i) || isNaN(r)) {
    error(["isNaN: int", i]);
  }

  return r;
};

export const nullableInt = (i: ?string | ?number): ?number => {
  if (i === null || i === undefined) return null;

  return int(i);
};

export const double = (i: string | number): numberDouble => {
  if (isNaN(i)) {
    error(["isNaN: Double", i]);
  } else {
    return new BigNumber(i);
  }
};

export const nullableDouble = (i: ?string | ?number): ?numberDouble => {
  if (i === null || i === undefined) return null;

  return double(i);
};



// WEBPACK FOOTER //
// ./src/redux/helpers/types.js